import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { invokeMock, viewMock, routerOpenMock } from './forge-mocks/frontend-mock-forge-bridge';

import '@atlaskit/css-reset';
const { invoke } = invokeMock();

ReactDOM.render(
  <React.StrictMode>
    <div style={{ textAlign: 'center', width: '100%', height: 15, fontSize: '11px', background: '#AA0114', padding: '4px', color: '#fff', fontWeight: 'bold' }}>!!! DEV MODE !!!</div>
    <App invoke={invoke} view={viewMock} routerOpen={routerOpenMock} />
  </React.StrictMode>,
  document.getElementById('root')
);
